// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display:inline-flex;justify-content:center;align-items:center}.zoom-label{font-size:12px;font-weight:700;width:28px;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
